import BaseAction from './BaseAction.js';
import {initializeEffect} from 'components/effects/constants.js';

class MoveEffectAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({from, to, isMidiEffect=false, track, group, send}) {
        let element = track || group || send;
        if (isMidiEffect) {
            element.midiEffects.moveEffectTo(from, to);
        } else {
            element.effectsChain.moveEffectTo(from, to);
        }
        if (track) {
            track.updateSteps();
        }
    }

    undo(action) {
    }

    serialize(action, id) {
        let json = super.serialize(action, id);
        let {operation} = json;
        let {payload} = operation;
        if (payload.group !== undefined) {
            payload.group = payload.group.groupNumber;
        }
        if (operation.send !== undefined) {
            payload.send = payload.send.sendNumber;
        }
        return json;
    }
}


export default MoveEffectAction;
